// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2CUwx","requiredAsterisk":"Info_requiredAsterisk__1-ssy"};